export enum Symbology {
  vGIS = 'vGIS',
  arcGIS = 'ArcGIS'
}
